export function Pricing() {
  const packages = [
    {
      name: 'Launch Package',
      popular: false,
      features: [
        'Ebook formatting',
        'Paperback setup',
        'Interior formatting',
        'ISBN guidance',
        'Distribution setup',
        '1 revision round',
        'Basic cover template',
        'Amazon listing optimization'
      ]
    },
    {
      name: 'Authority Package',
      popular: true,
      features: [
        'Everything in Launch',
        'Hardcover publishing',
        'Expanded distribution',
        'Amazon optimization',
        'Author bio development',
        'Author landing page',
        '2 revision rounds',
        'Custom cover design',
        'Marketing materials kit',
        'Priority email support'
      ]
    },
    {
      name: 'Signature Package',
      popular: false,
      features: [
        'Everything in Authority',
        'Press article draft',
        'Audiobook launch guidance',
        'Translation consultation',
        'Book trailer concept',
        'Adaptation review for screen potential',
        'Priority support',
        'Dedicated project manager',
        'Media kit creation',
        'Launch strategy session'
      ]
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="packages" className="bg-black py-36">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Title */}
        <div className="text-center mb-20">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            Publishing Packages
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            Choose Your Launch Path
          </h2>
          <p className="text-[#999999] text-lg max-w-md mx-auto">
            Select the package that fits your publishing goals and budget.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-3 gap-8 items-start">
          {packages.map((pkg, index) => (
            <div 
              key={index}
              className={`rounded-2xl overflow-hidden transition-all duration-300 ${
                pkg.popular 
                  ? 'scale-105 shadow-2xl shadow-[#D4AF37]/20 ring-2 ring-[#D4AF37]/50' 
                  : 'hover:scale-[1.02]'
              }`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="bg-[#D4AF37] text-black text-xs uppercase tracking-wider font-bold py-2 text-center">
                  Most Popular
                </div>
              )}

              {/* Header */}
              <div className="bg-gradient-to-b from-[#1A1A1A] to-[#252525] p-12 text-center">
                <div className="text-[#D4AF37] text-sm uppercase tracking-wider font-medium mb-3">
                  {pkg.name}
                </div>
                <div className="text-white text-2xl font-bold mb-2">
                  Custom Project Quote
                </div>
                <div className="text-[#999999] text-sm leading-snug max-w-[220px] mx-auto">
                  Tailored to your book goals, timeline, and publishing strategy.
                </div>
              </div>

              {/* Features */}
              <div className="bg-[#1C1C1C] p-12">
                <div className="text-[#D4AF37] text-sm uppercase tracking-wide font-medium mb-6">
                  Includes:
                </div>
                <ul className="space-y-4 mb-10">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-white text-base">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-2 flex-shrink-0"></span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Button */}
                <button 
                  onClick={scrollToContact}
                  className={`w-full h-13 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                    pkg.popular
                      ? 'bg-[#D4AF37] text-black hover:brightness-110'
                      : 'bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10'
                  }`}
                >
                  Request Proposal
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}